import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theory-course',
  templateUrl: './theory-course.component.html',
  styleUrls: ['./theory-course.component.css']
})
export class TheoryCourseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
